__turbopack_context__.v({
  "animatedDialog": "styles-module__TFUdOW__animatedDialog",
  "animatedDialogSafariHomepage": "styles-module__TFUdOW__animatedDialogSafariHomepage",
  "dialogClose": "styles-module__TFUdOW__dialogClose",
  "dialogOpen": "styles-module__TFUdOW__dialogOpen",
});
